import React from 'react'
import PrivateRoute from '../auth/PrivateRoute'
import { withRouter } from 'react-router-dom'
import ReservationTableContainer from './ReservationTableContainer'
import ReservationFormPage from './ReservationFormPage'
import AssignJobFormPage from './AssignJobFormPage'
import { findAccessLevel } from '../../modules/accessRoute'

export class ReservationPage extends React.Component {
  handleSubmit = () => {
    this.props.history.push(`/reservation`)
  }

  table = () => <ReservationTableContainer path="/reservation" />

  formPage = ({
    match: {
      params: { id },
    },
  }) => <ReservationFormPage id={id} onSubmit={this.handleSubmit} />
  assignJobPage = ({
    match: {
      params: { id },
    },
  }) => <AssignJobFormPage id={id} onSubmit={this.handleSubmit} />

  render() {
    return (
      <div>
        <PrivateRoute
          exact
          path="/reservation"
          component={this.table}
          ifAnyGranted={findAccessLevel('/reservation')}
        />

        <PrivateRoute
          path="/reservation/new"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/reservation')}
        />

        <PrivateRoute
          path="/reservation/edit/:id"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/reservation')}
        />

        <PrivateRoute
          path="/reservation/jobAssignments/:id"
          component={this.assignJobPage}
          ifAnyGranted={findAccessLevel('/reservation')}
        />
      </div>
    )
  }
}
export default withRouter(ReservationPage)
